// SWE/NOR org numbers are checksummed and drive the InExchange buyer-party lookup, so
// they stay digits-only. Every other country's number is only stored and printed, and
// foreign registration numbers routinely carry letters and separators.
const UNICODE_DASHES = /[–—‒−‐‑﹘﹣－]/g;
const NORDIC_DISALLOWED = /[^0-9-]/g;
const INTERNATIONAL_DISALLOWED = /[^A-Za-z0-9\-./ ]/g;
const MAX_LENGTH = 255; // Company.OrgNo is nvarchar(255)

export function hasOrgNoLookup(countryCode?: string | null) {
  const code = countryCode?.toUpperCase();
  return code === 'SWE' || code === 'NOR';
}

export function orgNoPolicy(countryCode?: string | null) {
  const hasLookup = hasOrgNoLookup(countryCode);

  return {
    hasLookup,
    sanitize(value: string | null | undefined) {
      const dashed = (value ?? '').toString().replace(UNICODE_DASHES, '-');
      // Deliberately not trimmed: trimming on every keystroke makes the space in
      // "HRB 12345" impossible to type. Emptiness is judged on the trimmed value instead.
      return dashed.replace(hasLookup ? NORDIC_DISALLOWED : INTERNATIONAL_DISALLOWED, '').slice(0, MAX_LENGTH);
    },
  };
}
